import {
  WORRY_FREE_RIGHT_POPINFO_DATA
} from '@/common/constant'

export default {
  /**
   * @description: 限制差旅城市列表
   * @param {*} state
   * @return {Array}
   */
  cityList(state,getters){
    return getters.travelInfo?.end_city_list ?? []
  },
  // 订单详情页退改无忧配置
  orderDetailWorryfreeRightPopupInfo(state) {
    const { service_extension } = state.base_info || {}
    return service_extension || WORRY_FREE_RIGHT_POPINFO_DATA
  },
}
